import { RefreshCw } from "lucide-react";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function RecoveryPage() {
  const auth = useAuth();
  const location = useLocation();
  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo?.startsWith("/")
    ? (location.state as { returnTo: string }).returnTo
    : "/atlas";

  const { user, profile, refreshProfile } = auth;

  useEffect(() => {
    if (!user || profile) return;
    const retry = window.setTimeout(() => void refreshProfile(), 1500);
    return () => window.clearTimeout(retry);
  }, [profile, refreshProfile, user]);

  if (auth.profile) return <Navigate to={returnTo} replace />;
  return (
    <div className="auth-status">
      <RefreshCw aria-hidden="true" />
      <h1>We’re reconnecting your account.</h1>
      <p>
        {auth.error ??
          "Your session is active, but your member profile is taking longer than expected to load. We’ll retry automatically."}
      </p>
      <button
        className="button button-gold"
        type="button"
        onClick={() => void auth.refreshProfile()}
      >
        Try again
      </button>
      <button className="quiet-button" type="button" onClick={() => void auth.signOut()}>
        Sign out
      </button>
    </div>
  );
}
